import React, {createContext, useContext, useReducer} from 'react';
import {actions, initialState} from './actions';
import {findPatientGet, findPatientPost, findSuspectDelete} from './api';
import {reducer} from './ManageVisit.reducer';

const ManageVisitContext = createContext();

const getErrorMessage = (error) =>
  error?.response?.data?.message || error?.message || 'Unable to load manage visit data';

const ManageVisitProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = {
    patient_post: state.patient_post,
    patient_object: state.patient_object,
    patient_get: state.patient_get,
    error_from_services: state.error_from_services,
    loading: state.loading,
    loading_post: state.loading_post,
    showAddModal: state.showAddModal,
    modalType: state.modalType,
    setModalType: (modalType) => {
      dispatch({ type: actions.SET_MODAL_TYPE, payload: modalType });
    },
    selectPatientPOST: (patient) => {
      dispatch({ type: actions.SELECT_PATIENT_POST, payload: patient });
    },
    toggleLoading: (loading) => {
      dispatch({ type: actions.TOGGLE_LOADING, payload: loading });
    },
    toggleAddModal: (show) => {
      dispatch({ type: actions.TOGGLE_SHOW_ADD_MODAL, payload: show });
    },
    findSuspectDelete: async (subVisitActivity) => await findSuspectDelete(subVisitActivity),
    findPatientPost: async (id) => {
      dispatch({ type: actions.TOGGLE_LOADING_POST, payload: true });
      try {
        const patient = await findPatientPost(id);
        dispatch({ type: actions.SELECT_PATIENT_POST, payload: patient.data });
      } catch (error) {
        dispatch({ type: actions.ERROR_FROM_SERVICES, payload: { errorMessage: getErrorMessage(error) } });
      } finally {
        dispatch({ type: actions.TOGGLE_LOADING_POST, payload: false });
      }
    },
    findPatientGet: async (id) => {
      dispatch({ type: actions.TOGGLE_LOADING, payload: true });
      try {
        const patient = await findPatientGet(id);
        const activityTypes = patient?.data?.manageVisitActivityTypeDtos || [];
        const hasDocument = activityTypes
          .filter(dto => dto?.name === 'Documentation And Coding')?.length > 0;
        const newPatient = {...patient?.data};

        if (!hasDocument) {
          newPatient.manageVisitActivityTypeDtos = [...activityTypes, {name: 'Documentation And Coding', visitActivitySubTypeDtos: []}];
        }
        dispatch({ type: actions.SELECT_PATIENT_GET, payload: newPatient });
      } catch (error) {
        dispatch({ type: actions.ERROR_FROM_SERVICES, payload: { errorMessage: getErrorMessage(error) } });
      } finally {
        dispatch({ type: actions.TOGGLE_LOADING, payload: false });
      }
    },
    persistPatientObject :async (firstName, lastName, fullName) => {
      dispatch({ type: actions.PERSIST_PATIENT_OBJECT, payload: {firstName:firstName,lastName:lastName,fullName:fullName} })
    },

    persistErrorMessage :async (errorMessage) => {
      dispatch({ type: actions.ERROR_FROM_SERVICES, payload: {errorMessage} })
    },

    addUploadFile: (careGapId, localEventId, fileUploads) => {
      dispatch({ type: actions.ADD_UPLOAD_FILE, payload: {careGapId, localEventId, fileUploads} })
    }
  };


  return (
    <ManageVisitContext.Provider value={value}>
      {children}
    </ManageVisitContext.Provider>
  )
};
const useManageVisitContext = () => useContext(ManageVisitContext);

export {
  ManageVisitProvider,
  useManageVisitContext,
}
